import content from "@/content/site-content.json";
import type { SiteContent } from "@/types/content";

const { header } = content as SiteContent;

export default function Header() {
  return (
    <header className="site-header">
      <div className="container site-header__inner">
        <a href="#" className="site-header__brand" aria-label="Mortensrud Fellesskap, til forsiden">
          <img src="/logo.jpeg" alt={header.logoAlt} width={44} height={44} />
          <span>
            Mortensrud
            <br />
            Fellesskap
          </span>
        </a>
        <nav aria-label="Hovedmeny">
          <ul className="site-header__nav">
            {header.nav.map((item) => (
              <li key={item.href}>
                <a href={item.href}>{item.label}</a>
              </li>
            ))}
          </ul>
        </nav>
        <a href="#kontakt" className="btn btn-primary site-header__cta">
          Ta kontakt
        </a>
      </div>

      <style>{`
        .site-header {
          position: sticky;
          top: 0;
          z-index: 20;
          background: rgba(251, 245, 240, 0.92);
          backdrop-filter: blur(8px);
          border-bottom: 1px solid var(--color-line);
        }
        .site-header__inner {
          display: flex;
          align-items: center;
          gap: var(--space-3);
          padding-top: var(--space-2);
          padding-bottom: var(--space-2);
        }
        .site-header__brand {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          text-decoration: none;
          color: var(--color-rosewood);
          font-family: var(--font-display);
          text-transform: uppercase;
          letter-spacing: var(--tracking-wordmark);
          font-size: 0.8rem;
          line-height: 1.3;
          font-weight: 500;
          margin-right: auto;
        }
        .site-header__brand img {
          border-radius: var(--radius-full);
        }
        .site-header__nav {
          list-style: none;
          display: flex;
          gap: var(--space-3);
          margin: 0;
          padding: 0;
        }
        .site-header__nav a {
          text-decoration: none;
          color: var(--color-ink);
          font-weight: 600;
          font-size: 0.95rem;
        }
        .site-header__nav a:hover {
          color: var(--color-clay);
        }
        .site-header__cta {
          padding: 0.6rem 1.2rem;
          font-size: 0.9rem;
        }
        @media (max-width: 760px) {
          .site-header__nav {
            display: none;
          }
        }
      `}</style>
    </header>
  );
}
